import React from "react";

function EnhancedSecurity() {
  return (
    <>
      <div className="award-style-one-area default-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">Achivement &amp; Awards</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  What does the Crypto Derivatives Exchange offer
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="award-style-one-items">
                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/1.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>Enhanced Security and Transparency</h4>
                  </div>
                  <div className="info">
                    <p>
                      Blockchain technology offers decentralized ownership,
                      secure transactions, and transparent operations, reshaping
                      gaming economies and enhancing user trust.
                    </p>
                  </div>
                  <div className="year">
                    <h2>01</h2>
                  </div>
                </div>

                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/2.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>Monetization Opportunities</h4>
                  </div>
                  <div className="info">
                    <p>
                      Blockchain gaming enables revenue through transaction
                      fees, item trades, royalties, and subscriptions, creating
                      a sustainable, monetized ecosystem.
                    </p>
                  </div>
                  <div className="year">
                    <h2>02</h2>
                  </div>
                </div>

                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/3.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>Efficient Micro-Payments and Revenue Management</h4>
                  </div>
                  <div className="info">
                    <p>
                      Enable fast, low-cost micro-transactions to add real-world
                      value to games. Subscription options, spending limits, and
                      minimal fees enhance monetization without impacting the
                      gaming experience.
                    </p>
                  </div>
                  <div className="year">
                    <h2>03</h2>
                  </div>
                </div>

                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/4.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>Reduced Revenue Losses</h4>
                  </div>
                  <div className="info">
                    <p>
                      Blockchain’s immutability minimizes chargeback losses and
                      fraudulent transactions, allowing developers to secure
                      their earnings effectively.
                    </p>
                  </div>
                  <div className="year">
                    <h2>04</h2>
                  </div>
                </div>
                <div className="award-style-one-item hover-active-item">
                  <div className="image-wrapper">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/brand/1.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="title">
                    <h4>In-Game Currency</h4>
                  </div>
                  <div className="info">
                    <p>
                      With blockchain, transactions are faster, safer, and more
                      economical. Players control their virtual assets, stored
                      directly in their wallets, creating a self-sustained
                      economy within the game.
                    </p>
                  </div>
                  <div className="year">
                    <h2>05</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EnhancedSecurity;
